/* eslint-disable jsx-a11y/label-has-associated-control */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment";
// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Settings page components
import MDInput from "components/MDInput";

// Data

function BasicInfo({ user }) {
  const ucFirst = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  const createdAt = useMemo(() => {
    if (user) {
      return moment(user.createdAt).format("LL");
    }
    return null;
  }, [user]);
  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3}>
        <MDTypography variant="h5">Basic Info</MDTypography>
      </MDBox>
      <MDBox pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDInput
              variant="standard"
              fullWidth
              label="First Name"
              inputProps={{ disabled: true, value: user?.firstName }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              fullWidth
              variant="standard"
              label="Last Name"
              inputProps={{ disabled: true, value: user?.lastName }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              variant="standard"
              fullWidth
              label="Joined"
              inputProps={{ disabled: true, value: createdAt }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              variant="standard"
              fullWidth
              label="Email"
              inputProps={{ disabled: true, value: user?.email }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              variant="standard"
              fullWidth
              label="Username"
              inputProps={{ disabled: true, value: user?.username }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              fullWidth
              variant="standard"
              label="Status"
              inputProps={{ disabled: true, value: ucFirst(user?.status || "") }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
BasicInfo.defaultProps = {
  user: {},
};

BasicInfo.propTypes = {
  user: PropTypes.shape(),
};
export default BasicInfo;
